import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { fetchTemplates } from '../../store/actions/broadcastAction';
import { getContactUsList, findUser } from '../../store/actions/userAction'
import Header from '../../components/Header'
import CssBaseline from '@material-ui/core/CssBaseline';
import Menubar from '../../components/Menubar';
import { Button, Grid, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { Typography, Box, Chip } from '@material-ui/core';
import CircleIcon from '@mui/icons-material/Circle';
import FileUploadSharpIcon from '@mui/icons-material/FileUploadSharp';
import FileDownloadSharpIcon from '@mui/icons-material/FileDownloadSharp';
import SearchIcon from '@mui/icons-material/Search';
import { styled, alpha } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import FormControl from '@mui/material/FormControl';
import NativeSelect from '@mui/material/NativeSelect';
import FilterAltSharpIcon from '@mui/icons-material/FilterAltSharp';
import ArrowDropDownSharpIcon from '@mui/icons-material/ArrowDropDownSharp';
import Moment from "moment"
import env from '../../env'

const useStyles = makeStyles((theme) => ({
    appBar: {
      position: 'relative',
    },
    layoutMainCreateApp: {
      background: "white",
      padding: "2rem 2rem",
      borderRadius: "10px",
      [theme.breakpoints.up("sm")]: {
        width: "80%",
        marginLeft: 'auto',
        marginRight: 'auto',
      },
    },
    stepper: {
      padding: theme.spacing(3, 0, 5),
    },
    buttons: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    button: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
      marginLeft: theme.spacing(1),
    },
    contentCreateApp : {
      paddingTop: "3%",
      paddingLeft: "15%",
      backgroundColor: "#e8e8e8",
      paddingRight: "0%",
      paddingBottom: "14%",

      [theme.breakpoints.down("sm")]: {
        paddingTop: "30%",
        paddingLeft: "0",
        paddingRight: "0"
      },
    },
}));

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}));

const columns = [
  { 
    id: 'fullName', 
    label: 'Nama', 
    minWidth: 50 
  },
  { 
    id: 'companyName', 
    label: 'Perusahaan', 
    minWidth: 50 
  },
  { 
    id: 'companySize', 
    label: 'Jumlah Karyawan', 
    minWidth: 50,
    align: 'center', 
  },
  { 
    id: 'department', 
    label: 'Departemen', 
    minWidth: 50,
    align: 'center', 
  },
  {
    id: 'email',
    label: 'Email',
    minWidth: 50,
    align: 'center'
  },
  {
    id: 'phoneNumber',
    label: 'Telepon',
    minWidth: 50,
    align: 'center'
  },
  {
    id: 'position',
    label: 'Posisi',
    minWidth: 50,
    align: 'center'
  },
  {
    id: 'service',
    label: 'Layanan',
    minWidth: 50,
    align: 'center'
  },
  {
    id: 'additionalInfo',
    label: 'Info',
    width: 150,
    align: 'center'
  }
];


const ContactUsList = () => {
  const dispatch = useDispatch()
  const classes = useStyles();
  const history = useHistory()
    
  const [page, setPage] = React.useState(0);
  const [rows, setRows] = React.useState([]);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };


  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleNewBroadcast = () => {
    history.push('/broadcast/newBroadcast')
  }

  useEffect(() => {
    dispatch(findUser())
  }, [dispatch])

  const user = useSelector(state => state.userReducer.userLogin)

  useEffect(() => {
    dispatch(fetchTemplates())
    if (user.email === env.SUPERADM) {
      dispatch(getContactUsList() )
    }    
  }, [dispatch, user])
  
  const contactUsList = useSelector(state => state.userReducer.contactUsList)
  const templates = useSelector(state => state.broadcastReducer.templates)

  useEffect(() => {
    const rowsData = []
    contactUsList?.forEach(data => {
      if (data.additionalInfo.length > 40) {
        data.additionalInfo = data.additionalInfo.slice(0, 40) + ' ...'
      }
      rowsData.push({
        id: data._id,
        fullName: data.fullName,
        companyName: data.companyName,
        companySize: data.companySize,
        department: data.department,
        email: data.email,
        phoneNumber: data.phoneNumber,
        position: data.position,
        service: data.service,
        additionalInfo: data.additionalInfo  
      })      
    })
    setRows(rowsData)
  }, [contactUsList])
          
  return (
        <React.Fragment>
        <Header page='Templates'/>
        <CssBaseline />
        <Menubar/>
        <Grid item xs={12} md={12} className={classes.contentCreateApp}>
          <main className={classes.layoutMainCreateApp}>
            <Grid container style={{position: 'relative'}}>
              <Box className="d-flex mb-15 w-100" style={{ justifyContent: 'space-between' }}>
                <div className="d-flex" style={{justifyContent:'space-between'}}>
                  <Search style={{border: "1px solid #dadada"}}>
                    <SearchIconWrapper>
                      <SearchIcon />
                    </SearchIconWrapper>
                    <StyledInputBase
                      placeholder="Cari Data"
                      className="font-size-14 mr-5"
                      inputProps={{ 'aria-label': 'search' }}
                    />
                  </Search>
                  <div className="d-flex ml-5" style={{justifyContent:"space-between", padding:"4px 3px", border: "1px solid #dadada"}}>
                    <FilterAltSharpIcon />
                    <ArrowDropDownSharpIcon />
                  </div>
                  <Button
                    className="ml-5 btn-white text-transform-unset"
                    >
                    <FileDownloadSharpIcon />
                  </Button>
                </div>
                <div className="d-flex" style={{justifyContent:'space-between'}}>
                  <span className="font-size-14 mt-5 mr-5"> Urut Berdasarkan: </span>
                  <Box sx={{ minWidth: 120 }}>
                    <FormControl fullWidth>
                      <NativeSelect
                        defaultValue={30}
                        inputProps={{
                          name: 'age',
                          id: 'uncontrolled-native',
                        }}
                        variant='outlined'
                        className="font-size-14"
                      >
                        <option value={10}>Status</option>
                        <option value={20}>Terlama</option>
                        <option value={30}>Terbaru</option>
                      </NativeSelect>
                    </FormControl>
                  </Box>
                </div>
              </Box>
              <Paper sx={{ width: '100%', overflow: 'hidden' }} className={classes.tableRoot}>
                <TableContainer sx={{ maxHeight: 380 }}>
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        <TableCell>
                          Nama Lengkap
                        </TableCell>
                        <TableCell  align="center">
                          Perusahaan
                        </TableCell>
                        <TableCell align="center">
                          Jumlah Karyawan
                        </TableCell>
                        <TableCell align="center">
                          Departemen
                        </TableCell>
                        <TableCell align="center">
                          Email
                        </TableCell>
                        <TableCell align="center">
                          Telepon
                        </TableCell>
                        <TableCell align="center">
                          Posisi
                        </TableCell>
                        <TableCell align="center">
                          Layanan
                        </TableCell>
                        <TableCell align="center">
                          Info
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody stripedRows >
                      {rows
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row) => {
                          return (
                            <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                              {columns.map((column) => {
                                const value = row[column.id];
                                return (
                                  <TableCell key={column.id} align={column.align}>
                                    {column.format && typeof value === 'number'
                                      ? column.format(value)
                                      : value}
                                  </TableCell>
                                );
                              })}
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  component="div"
                  count={rows.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Paper>
            </Grid>

          </main>
        </Grid>
      </React.Fragment>     
    )
}

export default ContactUsList
